import { pgettext } from '@sdk/lang/gettext';
import TimePicker from '@sdk/components/forms/TimePicker';

import { BreakRowProps } from '@web/timesheets/CreateTimesheetModal/components/rows/BreakRow/breakRow.types';
import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import { FieldContainer } from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';
import RemoveEntryButton from '@web/timesheets/CreateTimesheetModal/components/buttons/RemoveEntryButton';
import { useBreakRow } from '@web/timesheets/CreateTimesheetModal/components/rows/BreakRow/breakRow.hooks';
import { TimePickersRow } from '@web/timesheets/CreateTimesheetModal/components/rows/rows.styles';
import BreakIconSvg from '@web/assets/svg/Icons/32/break-gray.svg';
import { DEFAULT_INTERVAL_IN_MINUTES_FOR_TIME_PICKERS } from '@web/timeClock/constants';

const BreakRow = ({
  breakValue,
  fieldError,
  isLastEntry,
  submitBreakError,
  remove,
  update,
  timeClockFieldSet,
}: BreakRowProps) => {
  const {
    rowLabel,
    onStartBreakChange,
    usTimeFormat,
    isStartInvalid,
    onEndBreakChange,
    isEndInvalid,
    startBreakStartHour,
    startBreakEndHour,
    endBreakStartHour,
    endBreakEndHour,
  } = useBreakRow({
    breakValue,
    fieldError,
    isLastEntry,
    submitBreakError,
    update,
    timeClockFieldSet,
  });

  return (
    <ModalRow label={rowLabel} icon={BreakIconSvg}>
      <FieldContainer>
        <TimePickersRow>
          <TimePicker
            onChange={onStartBreakChange}
            prefix={pgettext(
              'specifing start break time in time clock period i.e. start 9 end 9:15',
              'Start'
            )}
            value={breakValue.start}
            intervalInMinutes={DEFAULT_INTERVAL_IN_MINUTES_FOR_TIME_PICKERS}
            usTimeFormat={usTimeFormat}
            invalid={isStartInvalid}
            startHour={startBreakStartHour}
            endHour={startBreakEndHour}
          />
          <TimePicker
            onChange={onEndBreakChange}
            prefix={pgettext(
              'specifing start break time in time clock period i.e. start 9 end 9:15',
              'End'
            )}
            value={breakValue.end}
            intervalInMinutes={DEFAULT_INTERVAL_IN_MINUTES_FOR_TIME_PICKERS}
            usTimeFormat={usTimeFormat}
            startHour={endBreakStartHour}
            endHour={endBreakEndHour}
            timeDifferenceBase={breakValue.start}
            invalid={isEndInvalid}
          />
          {<RemoveEntryButton onClick={() => remove(breakValue)} />}
        </TimePickersRow>
      </FieldContainer>
    </ModalRow>
  );
};

export default BreakRow;
